import { apiRequest } from '../api';
import type { MapType, TeamFormat } from './game-refs';

/** Карта в публичном разделе «Карты» вместе с голосами. */
export interface MapListItem {
  id: number;
  name: string;
  alt_name: string | null;
  map_types: MapType[];
  /** Форматы командной карты (только при типе team). */
  team_formats: TeamFormat[];
  player_count: number | null;
  author: string | null;
  link: string | null;
  /** Пометка «дисбалансная карта». */
  unbalanced: boolean;
  image_url: string | null;
  likes: number;
  dislikes: number;
  /** Мой голос: 1 — лайк, -1 — дизлайк, 0 — нет. */
  my_vote: number;
}

export interface MapVoteResult {
  likes: number;
  dislikes: number;
  my_vote: number;
}

export async function listMaps(token: string | null): Promise<MapListItem[]> {
  const res = await apiRequest<{ maps: MapListItem[] }>('/api/maps', { token });
  return res.maps;
}

export async function voteMap(
  id: number,
  value: 1 | -1 | 0,
  token: string | null
): Promise<MapVoteResult> {
  return apiRequest<MapVoteResult>(`/api/maps/${id}/vote`, {
    method: 'POST',
    token,
    body: { value },
  });
}
